import { forwardRef, type SVGProps } from 'react';

export type TextFilesProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const TextFiles = forwardRef<SVGSVGElement, TextFilesProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M5.5 26.89V5.11A1.61 1.61 0 017.11 3.5h17.78a1.61 1.61 0 011.61 1.61v21.78a1.61 1.61 0 01-1.61 1.61H7.11a1.61 1.61 0 01-1.61-1.61zm5.11-15h11.26m-11.26 4.8h11.26m-11.26 4.93H15"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
TextFiles.displayName = 'TextFiles';
